module.exports = __webpack_public_path__ + "static/media/unpin.27febfab.svg";